<template>
    <div class="switch__container">
        <div class="switch">
            <span 
                :style="{ color: textColor }" 
                :class="firstOption !== model ? 'switch__off' : ''"
            >
                {{ firstOption }}
            </span>
            <input
                ref="switch"
                type="checkbox"
                class="general-switch"
                @change="toggleChange"
                v-model="isChecked"
            >
            <span 
                :style="{ color: textColor }" 
                :class="secondOption !== model ? 'switch__off' : ''"
            >
                {{ secondOption }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: "GeneralSwitch",
    props: {
        value: {
            type: String,
            required: true
        },
        firstOption: {
            type: String,
            default: "Option 1"
        },
        secondOption: {
            type: String,
            default: "Option 2"
        },
        color: {
            type: String,
            default: "#dfdfdf"
        },
        secondaryColor: {
            type: String,
            default: "#dfdfdf"
        },
        jackColor: {
            type: String,
            default: "#51007a"
        },
        jackSecondaryColor: {
            type: String,
            default: "#51007a"
        },
        textColor: {
            type: String,
            default: "#FFFFFF"
        }
    },
    watch: {
        value(newValue) {
            this.model = newValue;
            this.isChecked = this.checked;
        }
    },
    computed: {
        checked() {
            return this.value === this.secondOption
        }
    },
    data() {
        return {
            model: this.value,
            isChecked: null
        }
    },
    mounted() {
        const elem = document.querySelector(".general-switch");
        new Switchery(elem, {
            color: this.color,
            secondaryColor: this.secondaryColor,
            jackColor: this.jackColor,
            jackSecondaryColor: this.jackSecondaryColor,
        });
    },
    methods: {
        toggleChange(evt) {
            if (evt.target.checked) {
                this.model = this.secondOption;
                this.$emit('input', this.model);
                this.isChecked = this.checked
            } else {
                this.model = this.firstOption;
                this.$emit('input', this.model);
                this.isChecked = this.checked
            }
        },
    }
}
</script>

<style lang="scss">
.switchery.switchery-default {
    margin: 0 10px;
}

.switchery.switchery-default small {
    top: -6px;
    left: -2px !important;
    height: 32px;
    width: 32px;
}

.general-switch:checked + .switchery.switchery-default small {
    left: 20px !important;
}
</style>

<style lang="scss" scoped>
.switch {
    display: flex;
    align-items: center;

    span {
        font-family: Akkurat-Light;
        font-size: 20px;
        font-weight: 300;
    }

    &__off {
        opacity: 0.3;
    }


}
</style>